<template>
  <click-to-edit
    v-model="scope.row.scale.achieved_date"
    type="date-picker"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.achieved_date')"
    placeholder="Внесите дату"
    @input="saveElementPropChange(scope.row, 'scale', {achieved_date:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'element-achieved-date-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
